/* eslint-disable */
import './style.scss'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import clsx from 'clsx'
import { TRANSLATION_NS } from '../../lib/apollo/config'

interface TopSkillsProps {
  talentClass: number
  amount?: number
  values?: number[] // overrides publicrating
  compareValues?: number[]
  oldTitle?: string
  newTitle?: string
  className?: string
  asCard?: boolean
  withHeadline?: boolean
  withValues?: boolean
  lastName: string
}

const TopSkills: React.FC<TopSkillsProps> = ({
  className,
  talentClass,
  amount = 4,
  values: v,
  withValues,
  lastName
}) => {
  const { t } = useTranslation(TRANSLATION_NS)
  
  const position = talentClass === 2 ? 'goalie.' : ''
  
  // map array of numbers to sorted index
  console.log(v)
  const values = useMemo(() => v
    ?.map((value, index) => ({ value, index }))
    .sort((a, b) => b.value - a.value)
    .slice(0, amount)
  , [v, amount])

  if (!values) return null

  return (
    <>
      <div
        className={clsx(className, 'talent-top-skills-25')}
      >
        <h2>{lastName}</h2>
        <div className='talent-top-skills-25__divider'></div>
        <div
          className='talent-top-skills-25__wrapper'
        >
          {values.map(({ index, value }, i) => {
            console.log(index, value)
            return (
              <div
                key={index}
                className='talent-top-skills-25__skill'
              >
                <span className='talent-top-skills-25__skill__name'>
                  {t(`i18n.certificate25.vote.${position}${index}.short`)}
                </span>
                <span className='talent-top-skills-25__skill__value'>
                  {value}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default TopSkills
